module.exports = __webpack_public_path__ + "img/netCore.4f7ba47a.svg";